import React from 'react';

interface EmptyPhotoProps {
    className?: string;
}

export const EmptyPhoto = ({ className }: EmptyPhotoProps) => {
    return <a className={className}>
        <div className="lds-heart"><div></div></div>
    </a>;
}